import { render, staticRenderFns } from "./StLegalEntityList.vue?vue&type=template&id=23da3300"
import script from "./StLegalEntityList.vue?vue&type=script&lang=ts"
export * from "./StLegalEntityList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports